import { render, staticRenderFns } from "./index-filter.vue?vue&type=template&id=5b0d5c45&scoped=true&"
import script from "./index-filter.vue?vue&type=script&lang=js&"
export * from "./index-filter.vue?vue&type=script&lang=js&"
import style0 from "./index-filter.vue?vue&type=style&index=0&id=5b0d5c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d5c45",
  null
  
)

export default component.exports